import React from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses, countDecimals } from '../../lib/ep.js';
import InputRange from 'react-input-range';

import FieldLabel from './FieldLabel';
import Tooltip from './Tooltip.js';

const Slider = (props) => {
	let value;

	if (props.value !== undefined) {
		value = props.value;
	} else if (props.model !== undefined && props.model[props.name] !== undefined) {
		value = props.model[props.name];
	}

	// Invalid value default => props.default
	if (
		(typeof value !== 'object' && ((value === 0 && props.min > 0) || value === undefined)) ||
		(typeof value === 'object' && (value.min === undefined || value.max === undefined))
	) {
		if (typeof props.default === 'object' && 'min' in props.default && 'max' in props.default) {
			value = {
				min: Math.round(props.default.min),
				max: Math.round(props.default.max),
			};
		} else if (props.default !== undefined) {
			value = Math.round(props.default);
		}
	}

	const min = parseFloat(props.min);
	const max = parseFloat(props.max);
	const step = props?.step ?? 1;
	const type = props?.type ?? false;
	const disabled = props?.disabled ?? false;

	const num_decimals = countDecimals(step);
	const multiplier = Math.pow(10, num_decimals);
	const _styles = props?._style ?? {};
	const _field_styles = props?._field_style ?? {};

	const change = (pos) => {
		if (disabled) return;
		if (props.change) {
			if (typeof pos === 'object' && 'min' in pos && 'max' in pos) {
				props.change(props.name, {
					min: pos.min / multiplier,
					max: pos.max / multiplier
				});
			} else {
				props.change(props.name, pos / multiplier);
			}
		}
	};

	let classname = props?.classname ?? 'input slide';
	classname = parseClasses(classname, props._class, 'range');
	if (type) classname += ' custom_icons_range';

	const field_c_class = ['field_container', 'slide_c'];
	const field_class = ['react_field'];
	if (props._field_class != undefined) field_class.push(props._field_class);
	if (disabled) {
		classname += ' disabledField ';
		field_c_class.push('disabledItem');
	}

	const inputRangeValue = (typeof value === 'object' && 'min' in value && 'max' in value)
		? {
			min: value.min * multiplier,
			max: value.max * multiplier
		}
		: value * multiplier;

	return (
		<div
			class={field_class.join(" ")}
			onMouseEnter={(disabled === false) ? props.onMouseEnter : null}
			onMouseLeave={(disabled === false) ? props.onMouseLeave : null}
			onClick={(disabled === false) ? props.onClick : null}
			style={_field_styles}
		>
			<div class={classname} style={_styles}>
				{(props.children) && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
					>{props.children}</FieldLabel>
				)}

				<div class={field_c_class.join(" ")}>
					{(type == 'rotate') && (
						<div class="icons">
							<span class="knk-rotate-cc" />
							<span class="knk-rotate-cw" />
						</div>
					)}

					{(type == 'zoom') && (
						<div class="icons">
							<span class="knk-zoom-out" />
							<span class="knk-zoom-in" />
						</div>
					)}

					{(type == 'fontsize') && (
						<div class="icons">
							<span class="knk-text gui_small_icon" />
							<span class="knk-text" />
						</div>
					)}

					<InputRange
						allowSameValues={true}
						className='u-slider-time'
						minValue={min * multiplier}
						maxValue={max * multiplier}
						value={inputRangeValue}
						step={step * multiplier}
						formatLabel={(value) => {
							return (multiplier > 1) ? (value / multiplier) : value;
						}}
						onChange={change}
					/>
				</div>
			</div>

			{(disabled) && (
				<Tooltip with_icon={false}>
					{props?.disabled_tooltip ?? "Disabled option"}
				</Tooltip>
			)}
		</div>
	);
}

export default injectIntl(Slider);